import { updateObject } from "../Utility";

const initialState = {
  leads: [],
  loading: false,
  syncLoading: false,
  syncMessage: null,
  syncErrors: null,
  importMessage: null,
  importLoading: false,
  pullMessage: null,
  pullLoading: false,
  submitMessage: null,
  submitLoading: false,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "ODEAL_LEAD_GET_ALL_PENDING":
      return updateObject(state, { loading: true, error: null });
    case "ODEAL_LEAD_GET_ALL_FULFILLED":
      return updateObject(state, {
        leads: action.payload || [],
        loading: false,
        error: null,
      });
    case "ODEAL_LEAD_GET_ALL_REJECTED":
      return updateObject(state, {
        loading: false,
        error: action.payload,
      });

    case "ODEAL_LEAD_SYNC_ALL_PENDING":
      return updateObject(state, {
        syncLoading: true,
        syncMessage: null,
        syncErrors: null,
      });
    case "ODEAL_LEAD_SYNC_ALL_FULFILLED":
      return updateObject(state, {
        syncLoading: false,
        syncMessage: action.payload,
        syncErrors: action.payload?.errors || null,
      });
    case "ODEAL_LEAD_SYNC_ALL_REJECTED":
      return updateObject(state, {
        syncLoading: false,
        syncMessage: null,
        error: action.payload,
      });

    case "ODEAL_LEAD_SYNC_STALE_PENDING":
      return updateObject(state, {
        syncLoading: true,
        syncMessage: null,
        syncErrors: null,
      });
    case "ODEAL_LEAD_SYNC_STALE_FULFILLED":
      return updateObject(state, {
        syncLoading: false,
        syncMessage: action.payload,
        syncErrors: action.payload?.errors || null,
      });
    case "ODEAL_LEAD_SYNC_STALE_REJECTED":
      return updateObject(state, {
        syncLoading: false,
        syncMessage: null,
        error: action.payload,
      });

    case "ODEAL_LEAD_IMPORT_CSV_PENDING":
      return updateObject(state, { importLoading: true, importMessage: null });
    case "ODEAL_LEAD_IMPORT_CSV_FULFILLED":
      return updateObject(state, {
        importLoading: false,
        importMessage: action.payload,
      });
    case "ODEAL_LEAD_IMPORT_CSV_REJECTED":
      return updateObject(state, {
        importLoading: false,
        importMessage: null,
        error: action.payload,
      });

    case "ODEAL_LEAD_PULL_BY_REF_PENDING":
      return updateObject(state, { pullLoading: true, pullMessage: null });
    case "ODEAL_LEAD_PULL_BY_REF_FULFILLED":
      return updateObject(state, {
        pullLoading: false,
        pullMessage: action.payload,
      });
    case "ODEAL_LEAD_PULL_BY_REF_REJECTED":
      return updateObject(state, {
        pullLoading: false,
        pullMessage: {
          error:
            action.payload?.response?.data?.error ||
            action.payload?.message ||
            "RF çekme başarısız.",
        },
      });

    case "ODEAL_LEAD_SUBMIT_PENDING":
      return updateObject(state, { submitLoading: true, submitMessage: null });
    case "ODEAL_LEAD_SUBMIT_FULFILLED":
      return updateObject(state, {
        submitLoading: false,
        submitMessage: action.payload,
      });
    case "ODEAL_LEAD_SUBMIT_REJECTED":
      return updateObject(state, {
        submitLoading: false,
        submitMessage: {
          error:
            action.payload?.response?.data?.error ||
            action.payload?.response?.data?.statusDetail ||
            action.payload?.message ||
            "Ödeal'a gönderim başarısız.",
        },
      });

    default:
      return state;
  }
};

export default reducer;
